import React from 'react';
import css from './BlogListSkeleton.module.css';

const Card = () => (
  <div className={css.card}>
    <div className={`${css.image} ${css.shimmer}`} aria-hidden />
    <div className={css.body}>
      <div className={`${css.tag} ${css.shimmer}`} />
      <div className={`${css.title} ${css.shimmer}`} />
      <div className={`${css.titleShort} ${css.shimmer}`} />
      <div className={`${css.desc} ${css.shimmer}`} />
      <div className={`${css.descShort} ${css.shimmer}`} />
    </div>
  </div>
);

/**
 * Placeholder grid for blog card carousels / store blog tab while data or Swiper loads.
 */
const BlogListSkeleton = ({ count = 3 }) => {
  const n = Math.max(1, Math.min(6, count));
  return (
    <div className={css.grid} role="status" aria-live="polite">
      {Array.from({ length: n }).map((_, i) => (
        <Card key={i} />
      ))}
    </div>
  );
};

export default BlogListSkeleton;
